import { Link, ResponsiveImage } from '@/components';
import { CategoryModel } from '@/types';
import { useTranslations } from 'next-intl';

type AtAGlanceInnovationPlatformsModel = {
  innovationPlatforms: CategoryModel[];
};

const AtAGlanceInnovationPlatforms = ({ innovationPlatforms }: AtAGlanceInnovationPlatformsModel) => {
  const t = useTranslations();
  return (
    <div className="flex w-full flex-col pl-6">
      <h3 className="my-4 h-7 text-lg leading-7 font-bold">{t('report.$innovationPlatforms')}</h3>
      <div className="flex flex-wrap gap-4">
        {innovationPlatforms.map((platform, index) => (
          <Link
            key={index}
            className="btn border-from-bg/20 color-from-bg border !px-7 !text-sm !font-medium tracking-[1.25px] hover:bg-[#b8ec95] hover:text-black"
            link={platform.landingPageLink}
          >
            {platform.icon && (
              <div className="h-5 w-5">
                <ResponsiveImage image={platform.icon} widths={{ xs: 20 }} heights={{ xs: 20 }} />
              </div>
            )}
            <span>{platform.categoryDisplayName}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AtAGlanceInnovationPlatforms;
